<header class="header">
  <div class="logo">
    <img ngSrc="assets/img/logo.png" priority="high" alt="logo" width="130" height="30" />
  </div>
  <div class="name">
    {{ 'appTitle' | translate }}
  </div>
  <div class="profile" [matMenuTriggerFor]="logoutMenu">
    <span class="username">
      {{ userProfile?.name }}
      <!-- @if (activeUserRoles()) {
        <span class="user-role"
          >({{ activeUserRoles().replaceAll(",", ", ") || "" }})</span
        >
      } -->
    </span>
    <span class="material-symbols-outlined">account_circle</span>
    <mat-menu #logoutMenu="matMenu" xPosition="before" yPosition="below">
      @if (isAdmin()) {
        <button mat-menu-item (click)="navigateToSettings()">
          <div class="flex">
            <span class="material-symbols-outlined">settings</span>
            <span>{{ 'settings' | translate }}</span>
          </div>
        </button>
        <button mat-menu-item (click)="downloadSummaryReport()">
          <div class="flex">
            <span class="material-symbols-outlined">overview</span>
            <span>{{ 'directorySummary' | translate }}</span>
          </div>
        </button>
      }
      <button mat-menu-item (click)="logoutUser()">
        <div class="flex">
          <span class="material-symbols-outlined">logout</span>
          <span>{{ 'logOut' | translate }}</span>
        </div>
      </button>
    </mat-menu>
  </div>
</header>
